export const LEAD_STORAGE_KEY = "automap_leads_v1";

/**
 * Production intake WhatsApp for quiz/multi-dealer flows (M18).
 * Set REACT_APP_AUTOMAPA_INTAKE_WHATSAPP in production — no placeholder fallback.
 */
function resolveAutomapIntakeWhatsapp() {
  const fromEnv = process.env.REACT_APP_AUTOMAPA_INTAKE_WHATSAPP?.replace(/\D/g, "");
  if (fromEnv && fromEnv.length >= 10) return fromEnv;
  if (process.env.NODE_ENV !== "production") return "573001234567";
  return null;
}

export const AUTOMAPA_INTAKE_WHATSAPP = resolveAutomapIntakeWhatsapp();

/** @deprecated use AUTOMAPA_INTAKE_WHATSAPP */
export const AUTOCLARO_INTAKE_WHATSAPP = AUTOMAPA_INTAKE_WHATSAPP;

export const LEAD_TYPES = {
  LISTING_INQUIRY: "listing_inquiry",
  QUIZ_REQUEST: "quiz_request",
  RECOMMENDATION_INQUIRY: "recommendation_inquiry",
  DEALER_CONTACT: "dealer_contact",
  FINANCING_INTEREST: "financing_interest",
  TEST_DRIVE_REQUEST: "test_drive_request",
  VIDEO_REQUEST: "video_request",
  PRICE_REQUEST: "price_request",
  AVAILABILITY_REQUEST: "availability_request",
};

export const LEAD_STATUSES = {
  NEW: "new",
  ROUTED: "routed",
  WHATSAPP_OPENED: "whatsapp_opened",
  CONTACTED: "contacted",
  NO_RESPONSE: "no_response",
  TEST_DRIVE_SCHEDULED: "test_drive_scheduled",
  NEGOTIATING: "negotiating",
  SOLD: "sold",
  LOST: "lost",
  BAD_LEAD: "bad_lead",
  ARCHIVED: "archived",
};

export const LEAD_TEMPERATURES = {
  ALTA: "alta_intencion",
  BUENA: "buena_oportunidad",
  EXPLORANDO: "explorando_opciones",
  INVESTIGACION: "investigacion_inicial",
};

export const DETAIL_ACTION_MAP = {
  confirmar_disponibilidad: {
    leadType: LEAD_TYPES.AVAILABILITY_REQUEST,
    sourceAction: "confirmar_disponibilidad",
    label: "Confirmar disponibilidad",
  },
  pedir_mejor_precio: {
    leadType: LEAD_TYPES.PRICE_REQUEST,
    sourceAction: "pedir_mejor_precio",
    label: "Pedir mejor precio",
  },
  agendar_test_drive: {
    leadType: LEAD_TYPES.TEST_DRIVE_REQUEST,
    sourceAction: "agendar_test_drive",
    label: "Agendar test drive",
  },
  preguntar_financiacion: {
    leadType: LEAD_TYPES.FINANCING_INTEREST,
    sourceAction: "preguntar_financiacion",
    label: "Preguntar por financiación",
  },
  solicitar_video: {
    leadType: LEAD_TYPES.VIDEO_REQUEST,
    sourceAction: "solicitar_video",
    label: "Solicitar video",
  },
  contactar_whatsapp: {
    leadType: LEAD_TYPES.LISTING_INQUIRY,
    sourceAction: "contactar_whatsapp",
    label: "Contactar por WhatsApp",
  },
};
